module.exports = __webpack_public_path__ + "media/chicken-road-jump_2.5ec1fe7f.mp3";